/**
 * The external dependencies.
 */
import React from 'react';
import {connect} from 'react-redux';
/**
 * The internal dependencies.
 */
import FormWrapper from '../../components/auth-form/wrapper';
import FormLink from '../../components/auth-form/link';
import FormBody from '../../components/auth-form/body';
import FormInput from '../../components/auth-form/input';
import FormLoginButton from '../../components/auth-form/button';
import {authRequestLogin} from '../../store/auth/actions';

class LoginForm extends React.Component {
    constructor() {
        super();

        this.state = {
            username: null,
            password: null,
        }
    }

    submitForm = (e) => {
        e.preventDefault();

        const {username, password} = this.state;

        this.props.authRequestLogin(username, password);
    };

    render() {
        return (
            <FormWrapper onSubmit={this.submitForm}>
                <FormBody>
                    <FormInput
                        onChange={(e) => this.setState({username: e.target.value})}
                        type="text"
                        name="username"
                        placeholder="Name / E-Mail"/>

                    <FormInput
                        onChange={(e) => this.setState({password: e.target.value})}
                        type="password"
                        name="password"
                        placeholder="Password"/>
                </FormBody>
                <FormLoginButton>Login</FormLoginButton>
                <FormLink to="/forgot-password">Kennwort vergessen?</FormLink>
            </FormWrapper>
        );
    }
}


export default connect(
    null, {
        authRequestLogin,
    }
)(LoginForm);



// WEBPACK FOOTER //
// ./src/containers/login-form/index.js